import React from 'react';
import styled from '@emotion/styled';
import nor1 from '../img/c1.jpeg';
import nor2 from '../img/c2.jpeg';
import nor3 from '../img/c3.jpeg';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { Link } from 'react-router-dom';
import  {Title,Div, Click, Span, Img} from './StyleComponents';


const Pg = styled.p`
	display: block;
	text-align: center;
	margin-bottom: 1.5rem;
`;

const Nordico = () => {
	return (
		<>
			<Link className='flecha' to={'/'}>
				&#60;{' '}
			</Link>

			<Click>(Precio válido por fotografía de dos personas)</Click>

			<Title>Cuadro Nórdico</Title>

			<AliceCarousel disableButtonsControls controlsStrategy='alternate'>
				<Img src={nor1} className='sliderimg' />
				<Img src={nor2} className='sliderimg' />
				<Img src={nor3} className='sliderimg' />
			</AliceCarousel>

			<Div>
				<Title>
					10 <Span>x</Span> 15 cm{' '}
					$25000
				</Title>
			</Div>
		</>
	);
};

export default Nordico;
